<div class="container">
  <div class="my-account-section row pr-2 pl-2">
    <div class="col-sm-12 col-md-12 col-lg-3 my-account-left-section endasureLeft">
      <app-kb-data-extraction-request-left-side-navigation></app-kb-data-extraction-request-left-side-navigation>
    </div>

    <div class="col-sm-12 col-md-12 col-lg-9 my-account-right-section endasureRight">
      @if (currentComponent === 'dataExtractionOverview') {
        <app-kb-data-extraction-overview
        ></app-kb-data-extraction-overview>
      }

      @if (currentComponent === 'customerVehicleOwner') {
        <app-kb-customer-vehicle-owner
        ></app-kb-customer-vehicle-owner>
      }

      @if (currentComponent === 'requestor') {
        <app-kb-requestor></app-kb-requestor>
      }

      @if (currentComponent === 'reportECURecipient') {
        <app-kb-report-ecu-recipient
        ></app-kb-report-ecu-recipient>
      }

      @if (currentComponent === 'vehicleInformation') {
        <app-kb-vehicle-information></app-kb-vehicle-information>
      }

      @if (currentComponent === 'eCUInformation') {
        <app-kb-ecu-information></app-kb-ecu-information>
      }

      @if (currentComponent === 'incidentInformation') {
        <app-kb-incident-information
        ></app-kb-incident-information>
      }

      @if (currentComponent === 'returnShippingInformation') {
        <app-kb-return-shipping-information
        ></app-kb-return-shipping-information>
      }
    </div>
  </div>
</div>